import { FC, useRef } from "react";
import { useAutofocus } from "@hooks/useAutofocus";
import { createFormikFields } from "@components/forms/fields/createFormikFields";
import { ClientFormSchema } from "./lib";
import styles from "./BillingTransferStep.module.scss";

const fields = createFormikFields<ClientFormSchema>();

export const BillingTransferStep: FC = () => {
    const inputRef = useRef<HTMLInputElement>(null);

    useAutofocus(inputRef);

    return (
        <>
            <p>Invite your client so they can set up billing.</p>

            <fields.Text
                size="xl"
                name="billingTransfer.email"
                label="Email address"
                ref={inputRef}
                className={styles.inputField}
            />
        </>
    );
};
